import {
  consonantArray,
  quizAnswersArray,
  transliterateDictionary,
  transliteratedIdDictionary,
  vowelArray,
  wordBySyllableDictionary,
} from "./WordDictionaries";

const sortRandomish = (array) => {
  // передбачуване випадкове сортування відповідей на щоденній
  // основі. допоки щось переініціалізовує компоненти карток,
  // я вирішив, сортувати відповіді на основі хешу слів-відповідей
  // та поточної дати
  const cyrb53 = function (str, seed = 0) {
    // щодня нове стабільне сортування
    let today = new Date();
    let dailySalt = today.getDate();
    str += dailySalt;
    let h1 = 0xdeadbeef ^ seed,
      h2 = 0x41c6ce57 ^ seed;
    for (let i = 0, ch; i < str.length; i++) {
      ch = str.charCodeAt(i);
      h1 = Math.imul(h1 ^ ch, 2654435761);
      h2 = Math.imul(h2 ^ ch, 1597334677);
    }
    h1 =
      Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^
      Math.imul(h2 ^ (h2 >>> 13), 3266489909);
    h2 =
      Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^
      Math.imul(h1 ^ (h1 >>> 13), 3266489909);
    return 4294967296 * (2097151 & h2) + (h1 >>> 0);
  };

  // sort quizAnswers based on word hash in number format
  return array.sort((a, b) => {
    return cyrb53(a) - cyrb53(b);
  });
};

const replaceWithObjectMatches = (str, mapObj) => {
  let regExp = new RegExp(Object.keys(mapObj).join("|"), "gi");
  return str.replace(regExp, function (matched) {
    return mapObj[matched];
  });
};

const transliterate = (str) => {
  return replaceWithObjectMatches(str, transliterateDictionary);
};

const getTransliteratedId = (str) => {
  return transliteratedIdDictionary[str];
};

const getWordBySyllable = (str) => {
  return wordBySyllableDictionary[str];
};

const testLowerCase = (syllable) => {
  // Handle null, undefined, or non-string inputs gracefully
  if (!syllable || typeof syllable !== 'string') {
    return true; // Consider null/undefined as "lowercase" (safe default)
  }
  return syllable === syllable.toLowerCase() ? true : false;
};

const getQuizAnswers = (correctAnswer, exceptions = []) => {
  // Handle null, undefined, or non-string inputs gracefully
  if (!correctAnswer || typeof correctAnswer !== 'string') {
    return ['Невідоме*']; // Return a safe default with correct answer marker
  }
  
  correctAnswer = correctAnswer.replace(/1/gi, "").toLowerCase();
  // remove correct answer from quizAnswersArray
  let quizAnswers = quizAnswersArray.filter(
    (answer) => answer !== correctAnswer
  );
  // видаляємо виключення, які збивають діток
  quizAnswers = quizAnswers.filter((item) => !exceptions.includes(item));

  // розбити слово на склади
  const correctAnswerSyllables = splitBySyllables(correctAnswer);
  // пройтися по всім варіантам, вносячи частотність входження складу до геш-таблиці
  let topQuizAnswers = {};
  correctAnswerSyllables.forEach((syllable) => {
    // цікавлять лише склади, а не окремі літери
    // байдуже, що втрачаються ї, о, а тощо
    // if (syllable.length < 2) return;
    quizAnswers.forEach((quizAnswer) => {
      if (quizAnswer.includes(syllable)) {
        // порахуємо кількість входжень складу в слово
        const rangeFactor = syllable.length;
        const currentCharacterOccurrences =
          (quizAnswer.match(new RegExp(syllable, "g")) || []).length *
          rangeFactor;
        if (topQuizAnswers[quizAnswer]) {
          topQuizAnswers[quizAnswer] += currentCharacterOccurrences;
        } else {
          topQuizAnswers[quizAnswer] = currentCharacterOccurrences;
        }
      }
    });
  });

  // вибираємо найбільш відповідні відповіді
  let topQuizAnswersArray = Object.keys(topQuizAnswers).sort(function (a, b) {
    return topQuizAnswers[b] - topQuizAnswers[a];
  });

  // зрізаємо вершки
  quizAnswers = topQuizAnswersArray.slice(0, 6);
  // додаємо правильну відповідь на початок масиву
  quizAnswers.unshift(`${correctAnswer}*`);

  quizAnswers.forEach((quizAnswer) => {
    // Перша літера велика
    quizAnswers[quizAnswers.indexOf(quizAnswer)] =
      quizAnswer.substring(0, 1).toUpperCase() + quizAnswer.substring(1);
  });

  return sortRandomish(quizAnswers);
};

const splitBySyllables = (currentWord) => {
  // Handle null, undefined, or non-string inputs gracefully
  if (!currentWord || typeof currentWord !== 'string') {
    return []; // Return empty array for invalid inputs
  }
  
  let vowel = vowelArray;
  let dashedWord = [];

  while (currentWord.length > 0) {
    // перша голосна?
    if (vowel.indexOf(currentWord.substring(0, 1)) >= 0) {
      if (currentWord.substring(1, 2) === "1") {
        // перший альтернативний склад?
        dashedWord.push(currentWord.substring(0, 2));
        currentWord = currentWord.substring(2);
      } else {
        dashedWord.push(currentWord.substring(0, 1));
        currentWord = currentWord.substring(1);
      }
    } // отже приголосна
    else {
      // друга голосна?
      if (vowel.indexOf(currentWord.substring(1, 2)) >= 0) {
        if (currentWord.substring(2, 3) === "1") {
          // альтернативний склад? забираємо одразу три
          dashedWord.push(currentWord.substring(0, 3));
          currentWord = currentWord.substring(3);
        } else {
          dashedWord.push(currentWord.substring(0, 2)); // забираємо одразу дві
          currentWord = currentWord.substring(2);
        }
      } else {
        // забираємо приголосну
        if (currentWord.substring(1, 3).toLowerCase() === "ьо") {
          // а раптом це "льо"?
          dashedWord.push(currentWord.substring(0, 3));
          currentWord = currentWord.substring(3);
        } else {
          if (
            currentWord.substring(1, 2).toLowerCase() === "ь" ||
            currentWord.substring(0, 2).toLowerCase() === "дж" ||
            (currentWord.substring(0, 2).toLowerCase() === "дз" &&
              // не «зьо»
              currentWord.substring(2, 4).toLowerCase() !== "ьо")
          ) {
            dashedWord.push(currentWord.substring(0, 2));
            currentWord = currentWord.substring(2);
          } else {
            if (currentWord.substring(1, 2) === "’") {
              dashedWord.push(currentWord.substring(0, 3));
              currentWord = currentWord.substring(3);
            } else {
              // таки просто приголосна
              dashedWord.push(currentWord.substring(0, 1));
              currentWord = currentWord.substring(1);
            }
          }
        }
      }
    }
  }
  return dashedWord;
};

const isNotConsonant = (syllable) => {
  return consonantArray.indexOf(syllable.toLowerCase()) < 0;
};

export {
  transliterate,
  getTransliteratedId,
  getWordBySyllable,
  testLowerCase,
  getQuizAnswers,
  splitBySyllables,
  isNotConsonant,
};
